module.exports = __webpack_public_path__ + "static/media/dora.645ca5e1.png";